import React from 'react';
import '../css/homeStretch.css';

export class FreshFav extends React.Component {
	render() {
		return (
			<div>
				<div>
					<hr className="thin-horiz-line" />
				</div>

				<div className="homestretch-content">
					<div className="container-title">
						<h4>fresh favorites</h4>
					</div>

					<div className="homestretch-text-container">
						<div className="homestretch-text">
							<a
								className="homestretch-link"
								href="https://www.kickstarter.com/projects/woostergroup/the-wooster-group-the-mother-help?ref=section-homepage-projectcollection-1-staff-picks-newest"
								target="_blank"
								rel="noopener  noreferrer"
							>
								<img className="homestretch-image" src={require('../images/ff-mother.jpg')} alt="" />
								<br />
								THE WOOSTER GROUP / THE MOTHER / HELP!
							</a>

							<a
								className="link-no-underline"
								href="https://www.kickstarter.com/projects/woostergroup/the-wooster-group-the-mother-help?ref=section-homepage-projectcollection-1-staff-picks-newest"
								target="_blank"
								rel="noopener  noreferrer"
							>
								<br />
								<p>
									Help The Wooster Group bring to life Brecht’s play The Mother (meant to incite
									social change) (and entertain at the same time).
								</p>
							</a>
							<a
								className="black-link"
								href="https://www.kickstarter.com/projects/woostergroup/the-wooster-group-the-mother-help?ref=section-homepage-projectcollection-1-staff-picks-newest"
								target="_blank"
								rel="noopener  noreferrer"
							>
								<br />
								By <span className="name-underline">The Wooster Group</span>
							</a>
						</div>

						<div className="homestretch-text">
							<a
								className="homestretch-link"
								href="https://www.kickstarter.com/projects/thedollyrots/the-dollyrots-eat-my-heart-out-vinyl-reissue?ref=section-homepage-projectcollection-2-staff-picks-newest"
								target="_blank"
								rel="noopener  noreferrer"
							>
								<img
									className="homestretch-image"
									src={require('../images/ff-dollyrots.png')}
									alt=""
								/>{' '}
								<br />
								The Dollyrots: "Eat My Heart Out" Vinyl Reissue!
							</a>

							<a
								className="link-no-underline"
								href="https://www.kickstarter.com/projects/thedollyrots/the-dollyrots-eat-my-heart-out-vinyl-reissue?ref=section-homepage-projectcollection-2-staff-picks-newest"
								target="_blank"
								rel="noopener  noreferrer"
							>
								<br />
								<p>
									On its 15th Anniversary we're reissuing our debut album "Eat My Heart Out" on
									limited deluxe vinyl!
								</p>
							</a>
							<a
								className="black-link"
								href="https://www.kickstarter.com/projects/thedollyrots/the-dollyrots-eat-my-heart-out-vinyl-reissue?ref=section-homepage-projectcollection-2-staff-picks-newest"
								target="_blank"
								rel="noopener  noreferrer"
							>
								<br />
								By <span className="name-underline">The Dollyrots</span>
							</a>
						</div>

						<div className="homestretch-text">
							<a
								className="homestretch-link"
								href="https://www.kickstarter.com/projects/nichtlustig/moviecliches?ref=section-homepage-projectcollection-3-staff-picks-newest"
								target="_blank"
								rel="noopener  noreferrer"
							>
								<img
									className="homestretch-image"
									src={require('../images/ff-movie.png')}
									alt=""
								/>{' '}
								<br />
								MOVIE CLICHÉS - the card game
							</a>

							<a
								className="link-no-underline"
								href="https://www.kickstarter.com/projects/nichtlustig/moviecliches?ref=section-homepage-projectcollection-3-staff-picks-newest"
								target="_blank"
								rel="noopener  noreferrer"
							>
								<br />
								<p>A card game made by (bad) movies.</p>
							</a>
							<a
								className="black-link"
								href="https://www.kickstarter.com/projects/nichtlustig/moviecliches?ref=section-homepage-projectcollection-3-staff-picks-newest"
								target="_blank"
								rel="noopener  noreferrer"
							>
								<br />
								By <span className="name-underline">Joscha Sauer</span>
							</a>
						</div>

						<div className="homestretch-text">
							<a
								className="homestretch-link"
								href="https://www.kickstarter.com/projects/elaineyounglabyrinth/amula-personalized-dna-jewellery?ref=section-homepage-projectcollection-4-staff-picks-newest"
								target="_blank"
								rel="noopener  noreferrer"
							>
								<img
									className="homestretch-image"
									src={require('../images/ff-amula.jpg')}
									alt=""
								/>{' '}
								<br />
								Amula | Personalized DNA Jewellery
							</a>

							<a
								className="link-no-underline"
								href="https://www.kickstarter.com/projects/elaineyounglabyrinth/amula-personalized-dna-jewellery?ref=section-homepage-projectcollection-4-staff-picks-newest"
								target="_blank"
								rel="noopener  noreferrer"
							>
								<br />
								<p>A modern twist on the traditional locket.</p>
							</a>

							<a
								className="black-link"
								href="https://www.kickstarter.com/projects/elaineyounglabyrinth/amula-personalized-dna-jewellery?ref=section-homepage-projectcollection-4-staff-picks-newest"
								rel="noopener  noreferrer"
							>
								<br />
								By <span className="name-underline">Elaine Young</span>
							</a>
						</div>

						<div className="homestretch-text">
							<a
								className="homestretch-link"
								href="https://www.kickstarter.com/projects/impostersshow/imposters?ref=section-homepage-projectcollection-5-staff-picks-newest"
								target="_blank"
								rel="noopener  noreferrer"
							>
								<img
									className="homestretch-image"
									src={require('../images/ff-imposters.png')}
									alt=""
								/>{' '}
								<br />
								Imposters
							</a>

							<a
								className="link-no-underline"
								href="https://www.kickstarter.com/projects/impostersshow/imposters?ref=section-homepage-projectcollection-5-staff-picks-newest"
								target="_blank"
								rel="noopener  noreferrer"
							>
								<br />
								<p>
									A group of hapless students are roped into a "diversity" initiative when an elite
									university gets accused of white supremacy ties.
								</p>
							</a>
							<a
								className="black-link"
								href="https://www.kickstarter.com/projects/impostersshow/imposters?ref=section-homepage-projectcollection-5-staff-picks-newest"
								target="_blank"
								rel="noopener  noreferrer"
							>
								<br />
								By <span className="name-underline">Sandie Cheng</span>
							</a>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
